import React, {useState, useEffect} from "react";
import svulogo from '../assets/images/svulogo.webp';
import { Link, useLocation } from "react-router-dom";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from 'sweetalert2';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye, faArrowRightFromBracket, faArrowRightToBracket, faBars, faCaretDown, faCaretUp, faArrowRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import {faSquareCaretDown, faSquareCaretUp} from "@fortawesome/free-regular-svg-icons";
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';

const Header = () => {

  const location = useLocation();
  const [sticky, setSticky] = useState("");

  const [coursedata, setcoursedata] = useState([]);
  const [showloading, setshowloding] = useState(false);
  const [open, setOpen] = useState(false);
  const [showaboutusdropdown, setshowaboutusdropdown] = useState(false);
  const [showalumnidropdown, setshowalumnidropdown] = useState(false);
  const [showcoursewisealumnidropdown, setshowcoursewisealumnidropdown] = useState(false);
  const [showijcapdropdown, setshowijcapdropdown] = useState(false);

  const isSticky = () => {
    /* Method that will fix header after a specific scrollable */
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 250 ? "is-sticky" : "";
    setSticky(stickyClass);
    console.log(stickyClass);
  };

  const classes = `headerdiv ${sticky} mobhide`;


  const toggleDrawer = (state) => {
    setOpen(state);
  };

  const fetchcourses = async() => {
    setshowloding(true);
      const headers = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let resp = await axios
        .get(apiUrl + "getuserallalumnicourses", headers)
        .then((res) => {
          if (res.data.status == "success") {
            // console.log('getallcategories >>', res.data);
            var prevdata = res.data.data;
            console.log('prevdata >>', prevdata);
            setcoursedata(prevdata);
            
            // setcoursesdata(res.data.data);
          } else {
            // alert(res.data.message);
          }
        })
        .catch((err) => {
          alert(err.message);
        });
        setshowloding(false);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    setOpen(false)
  }, [location]);

  useEffect(() => {
    fetchcourses();
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };

   
  }, []);

    return (
      <>
        <div className={classes}>
          <div className="">
          <div className=" text-center">
            <img src={svulogo} alt="Logo" className="website-logo" />
          </div>
          <div className="desktopheaderdiv">
          <nav className="navbar navbar-expand-lg  custom-nav ">
            <div className="container">
              <ul className="navbar-nav ">
                <li className="nav-item active">
                  <Link to="/" className="text-light text-decoration-none">
                    {" "}
                    <p className="nav-link active-link" href="#">
                      Home
                    </p>
                  </Link>
                </li>

                <li className="nav-item dropdown hover-dropdown">
                  <p
                    className="nav-link dropdown-toggle "
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                  >
                    About Us
                  </p>
                  <div className="dropdown-menu">
                    <Link
                      to="/aboutdepartment"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        About Department
                      </p>
                    </Link>
                    <Link
                      to="/aboutalumniassociaton"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        About Alumni Association
                      </p>
                    </Link>
                    <Link
                      to="/headsofthedepartment"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        Heads of the Department
                      </p>
                    </Link>
                  </div>
                </li>

                <li className="nav-item dropdown hover-dropdown">
                  <p
                    className="nav-link dropdown-toggle "
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                  >
                    Alumni
                  </p>
                  <div className="dropdown-menu">
                    <Link
                      to="/alumnicommitee"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        Alumni Committee
                      </p>
                    </Link>
                    <Link
                      to="/alumniregistration"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        Alumni Registration
                      </p>
                    </Link>
                  </div>
                </li>
                <li className="nav-item dropdown hover-dropdown">
                  <p
                    className="nav-link dropdown-toggle "
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                  >
                    Course Wise Alumni
                  </p>
                  <div className="dropdown-menu">
                    {coursedata?.length > 0
                      ? coursedata?.map((item, index) => {
                          return (
                            <Link
                              to={"/course/" + item?.slug}
                              key={index}
                              className="text-light text-decoration-none"
                            >
                              <p className="dropdown-item" href="#">
                                {item?.name}
                              </p>
                            </Link>
                          );
                        })
                      : null}
                    {/* <Link to="/m-sc-zoology" className="text-light text-decoration-none"><p className="dropdown-item" href="#">M Sc (Zoology)    </p></Link>
                <p className="dropdown-item" href="#">Ph D (Zoology)    </p>
                <p className="dropdown-item" href="#">M Sc (Animal Biotechnology)    </p>
                <p className="dropdown-item" href="#">M Sc ( Bio Informatics)    </p>
                <p className="dropdown-item" href="#">M Sc (Sericulture)    </p> */}
                  </div>
                </li>

                <li className="nav-item dropdown hover-dropdown">
                  <p
                    className="nav-link dropdown-toggle "
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                  >
                    IJCAP
                  </p>
                  <div className="dropdown-menu">
                    <Link
                      to="/ijcapjournals"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        IJCAP Journals
                      </p>
                    </Link>
                    <Link
                      to="/ijcapsociety"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="dropdown-item" href="#">
                        IJCAP Society
                      </p>
                    </Link>
                  </div>
                </li>

                <li className="nav-item">
                  <Link
                    to="/gallery"
                    className="text-light text-decoration-none"
                  >
                    {" "}
                    <p className="nav-link" href="#">
                      Gallery
                    </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/events"
                    className="text-light text-decoration-none"
                  >
                    {" "}
                    <p className="nav-link" href="#">
                      Events
                    </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/museum"
                    className="text-light text-decoration-none"
                  >
                    {" "}
                    <p className="nav-link" href="#">
                      Museum
                    </p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/contactus"
                    className="text-light text-decoration-none"
                  >
                    {" "}
                    <p className="nav-link" href="#">
                      Contact Us
                    </p>
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
          </div>
          
          </div>
          <div className="deskstickyheight" />
          
        </div>

        <div className="deskhide">
          <div className="mobilemaindiv">
            <div
              className="mobilemenudiv"
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faBars} className="menubaricon" />
            </div>
            <img src={svulogo} alt="Logo" className="website-logo" />
          </div>
          <div className="navbarheight" />

          {/* Drawer */}
          <Drawer
            anchor="left"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 250 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <ul className="navbar-nav ">
                  <li className="nav-item active">
                    <Link to="/" className="text-light text-decoration-none">
                      {" "}
                      <p className="nav-link active-link" href="#">
                        Home
                      </p>
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <p
                      className="nav-link dropdown-toggle "
                      onClick={() => {
                        setshowaboutusdropdown(!showaboutusdropdown);
                      }}
                    >
                      About Us
                    </p>
                    {showaboutusdropdown ? (
                      <div className="">
                        <li className="nav-item">
                          <Link
                            to="/aboutdepartment"
                            className="text-light text-decoration-none"
                          >
                            {" "}
                            <p className="dropdown-item" href="#">
                              About Department
                            </p>
                          </Link>
                        </li>
                        <li className="nav-item">
                        <Link
                          to="/aboutalumniassociaton"
                          className="text-light text-decoration-none"
                        >
                          {" "}
                          <p className="dropdown-item" href="#">
                            About Alumni Association
                          </p>
                        </Link>
                        </li>
                        <li className="nav-item">
                        <Link
                          to="/headsofthedepartment"
                          className="text-light text-decoration-none"
                        >
                          {" "}
                          <p className="dropdown-item" href="#">
                            Heads of the Department
                          </p>
                        </Link>
                        </li>


                        
                        
                      </div>
                    ) : null}
                  </li>

                  <li className="nav-item dropdown hover-dropdown">
                    <p
                      className="nav-link dropdown-toggle "
                      onClick={() => {
                        setshowalumnidropdown(!showalumnidropdown);
                      }}
                    >
                      Alumni
                    </p>
                    {
                      showalumnidropdown ?
                      <div className="">
                        <li className="nav-item">
                        <Link
                        to="/alumnicommitee"
                        className="text-light text-decoration-none"
                      >
                        {" "}
                        <p className="dropdown-item" href="#">
                          Alumni Committee
                        </p>
                      </Link>
                        </li>
                        <li className="nav-item">
                        <Link
                        to="/alumniregistration"
                        className="text-light text-decoration-none"
                      >
                        {" "}
                        <p className="dropdown-item" href="#">
                          Alumni Registration
                        </p>
                      </Link>
                        </li>
                      
                      
                    </div> : null
                    }
                    
                  </li>
                  <li className="nav-item dropdown hover-dropdown">
                    <p
                      className="nav-link dropdown-toggle "
                      onClick={() => {
                        setshowcoursewisealumnidropdown(!showcoursewisealumnidropdown);
                      }}
                    >
                      Course Wise Alumni
                    </p>
                    {
                      showcoursewisealumnidropdown ?
                      <div className="">
                      {coursedata?.length > 0
                        ? coursedata?.map((item, index) => {
                            return (
                              <li className="nav-item">
                                <Link
                                to={"/course/" + item?.slug}
                                key={index}
                                className="text-light text-decoration-none"
                              >
                                <p className="dropdown-item" href="#">
                                  {item?.name}
                                </p>
                              </Link>
                              </li>
                              
                            );
                          })
                        : null}
                    </div> : null
                    }
                    
                  </li>

                  <li className="nav-item dropdown hover-dropdown">
                    <p
                      className="nav-link dropdown-toggle "
                      onClick={() => {
                        setshowijcapdropdown(!showijcapdropdown);
                      }}
                    >
                      IJCAP
                    </p>
                    {
                      showijcapdropdown ?
                      <div className="">
                    <li className="nav-item">
                    <Link
                        to="/ijcapjournals"
                        className="text-light text-decoration-none"
                      >
                        {" "}
                        <p className="dropdown-item" href="#">
                          IJCAP Journals
                        </p>
                      </Link>
                    </li>
                    <li className="nav-item">
                    <Link
                        to="/ijcapsociety"
                        className="text-light text-decoration-none"
                      >
                        {" "}
                        <p className="dropdown-item" href="#">
                          IJCAP Society
                        </p>
                      </Link>
                    </li>
                      
                      
                    </div> : null
                    }
                    
                  </li>

                  <li className="nav-item">
                    <Link
                      to="/gallery"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="nav-link" href="#">
                        Gallery
                      </p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/events"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="nav-link" href="#">
                        Events
                      </p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/museum"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="nav-link" href="#">
                        Museum
                      </p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/contactus"
                      className="text-light text-decoration-none"
                    >
                      {" "}
                      <p className="nav-link" href="#">
                        Contact Us
                      </p>
                    </Link>
                  </li>
                </ul>
              </div>
              {/* {['Dashboard', 'Profile', 'Settings', 'Logout'].map((text) => (
            <ListItem button key={text}>
              <ListItemText primary={text} />
            </ListItem>
          ))} */}
            </List>
          </Drawer>
        </div>
      </>
    );
}

export default Header;